module.exports = __webpack_public_path__ + "media/images/ordi2-022a9e9424620ee97ab85828e28d05ee.png";